






















































































































































































































































































































































































































































































































import { Vue, Component,Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg,PaginationAdminPanel } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import ListFilterPanelAdmin from '@/components/ListFilterPanelAdmin.vue'
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { AddressBookApi } from '@/http';
import BaseInfoPanelBook from '@/components/BaseInfoPanelBook.vue';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        ListFilterPanelAdmin,
        AddressSelect,
        SearchPanel,
        DraggerImg,
        PaginationAdminPanel,
        BaseInfoPanelBook,
    },
})
export default class addressBook extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public addressType = enums.addressType;
    public stateType = enums.stateType;
    // 发货方
    public companyNames = [];
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public dialogVisibleAdmin = false;
    public handleClose() {
        this.dialogVisible = false;
    }
     public handleCloseAdmin() {
        this.dialogVisibleAdmin = false;
    }
    public defaultPropAdmin = {
        label:'text',
        children:'children'
    }
    // public defaultPropAdmin2 = {
    //     label:'text',
    // }
    public defaultProp = {
        label:'label',
        children:'children'
    }
    public content = '';
    public selectReset = false;
    /**
     * 地址识别
     */
    // public getAddressCode(content) {
    //     this.selectReset = false;
    //     AddressBookApi.AddressDistinguish(content).then((res) => {
    //         if (res.province != '') {
    //             this.SelectAddress.province.value = res.province;
    //             this.SelectAddress.city.value = res.city;
    //             this.SelectAddress.area.value = res.county;
    //             this.formData.detail = res.details;
    //             this.formData.contactName = res.name;
    //             this.formData.phoneNumber = res.phone;
    //             this.selectReset = true;
    //         } else {
    //             this.SelectAddress.province.value = '';
    //             this.SelectAddress.city.value = '';
    //             this.SelectAddress.area.value = '';
    //             this.formData.detail = '';
    //              this.formData.contactName = '';
    //             this.formData.phoneNumber = '';
    //             this.selectReset = true;
    //         }
    //     });
    // }

    // public sort(col): void {
    //     if (col.order == 'ascending') {
    //         this.searchValue.asc = true;
    //     } else {
    //         this.searchValue.asc = false;
    //     }
    //     switch (col.prop) {
    //         case 'creationTime':
    //             {
    //                 this.searchValue.orderBy = '1';
    //             }
    //             break;
    //     }
    //     this.loadData();
    // }

    //---地址选择start---

    public startPlaceLongitude = '';
    public startPlaceLatitude = '';
    /**
     * 地址选择（发货地址）
     */
    public handlStarteSelect(item) {
        this.startPlaceLongitude = item.point.lng;
        this.startPlaceLatitude = item.point.lat;
    }
    /**
     * 高德关键词检索(送货地址)
     */
    public async querySearchStartAsync(queryString, cb) {
        if (queryString.length < 2) return;

        this.startPlaceLongitude = '';
        this.startPlaceLatitude = '';
        const data = [];

        // 配置搜索参数（参考高德API文档）
        const searchOptions = {
            city: this.formData.cityStr || '全国', // 优先使用表单中的城市，默认全国
            pageSize: 20,          // 每页结果数
            pageIndex: 1,          // 页码
            extensions: 'all'      // 返回完整信息
        };
        // console.log("searchOptions:", searchOptions);

        // 初始化高德地点搜索服务
        AMap.plugin('AMap.PlaceSearch', () => {
            const placeSearch = new AMap.PlaceSearch(searchOptions);

            // 执行搜索请求
            placeSearch.search(queryString, (status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                    const pois = result.poiList.pois;

                    pois.forEach(poi => {
                        // console.log("poi:", poi);
                        // 解析坐标点（高德坐标格式："经度,纬度"）
                        const lng = poi.location.lng;
                        const lat = poi.location.lat;

                        data.push({
                            title: poi.name,
                            address: `${poi.cityname}${poi.adname}${poi.address}`,
                            searchvalue: `${poi.name}${poi.address ? '('+poi.address+')' : ''}`,
                            point: {
                                lng: parseFloat(lng),
                                lat: parseFloat(lat)
                            }
                        });
                    });

                    // 返回格式化数据
                    cb(data.map(e => ({
                        title: e.title,
                        address: e.address,
                        value: e.searchvalue,
                        point: e.point
                    })));
                } else {
                    console.error('高德搜索失败:', result.info);
                    cb([]);
                }
            });
        });
    }

    public startAddress = '';
    public async updateReset() {
        this.selectReset = false;
    }

    public SelectAddress = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    public async getProvince(item, name) {
        this.formData.province = item;
        this.formData.provinceStr = name;
    }

    public async getCityCode(item, name) {
        this.formData.city = item;
        this.formData.cityStr = name;
    }

    public async getAreaCode(item, name) {
        this.formData.district = item;
        this.formData.districtStr = name;
        this.startAddress = this.formData.provinceStr + this.formData.cityStr + this.formData.districtStr;
    }

    public searchValue: any = {
        addressName:'',
        addressCode:'',
        // enabled:true,
    };
    public addressInputName = '';
    // 运输区域输入框发生改变
    public addressInputNameChange(val){
        this.searchValue.addressName = val;
    }
    public searchAdminValue:any = {
         zoneCode:'',
         zoneName:'',
        //  enabled:true,
    }
    public searchAdminTreeValue:any = {
       zoneName:'',
    }
    public searchTreeValue:any = {
       addressName:'',
    }
    public timeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('addressBook', JSON.stringify(this.colData));
    }
     public colData = JSON.parse(localStorage.getItem('addressBook'))
        ? JSON.parse(localStorage.getItem('addressBook'))
        : [
              { title: '运输区域编码', isShow: true, disabled: false },
              { title: '运输区域', isShow: true, disabled: false },
              { title: '地址', isShow: true, disabled: false },
              { title: '联系人', isShow: true, disabled: false },
              { title: '联系人电话', isShow: true, disabled: false },
            //   { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedAdminChange(){
         let newDate = this.colAdminData.filter((item) => item.isShow == false);
        if (this.colAdminData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colAdminData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colAdminData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('addressBookAdmin', JSON.stringify(this.colAdminData));
    }
    public colAdminData = JSON.parse(localStorage.getItem('addressBookAdmin'))
        ? JSON.parse(localStorage.getItem('addressBookAdmin'))
        : [
              { title: '编码', isShow: true, disabled: false },
              { title: '名称', isShow: true, disabled: false },
              { title: '全称', isShow: true, disabled: false },
              { title: '上级行政区域', isShow: true, disabled: false },
            //   { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }

    public labelPosition: string = 'right';

    public $refs!: {
        paginationAdmin:HTMLFormElement;
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        multipleTableAdmin:HTMLFormElement;
        formData: HTMLFormElement;
        formDataAdmin: HTMLFormElement;
        address: HTMLFormElement;
        draggerImg: HTMLFormElement;
        vAdmintree:HTMLFormElement;
        vtree: HTMLFormElement;
    };
    public searchAdminFunc(){
       this.loadAdminData();
       sessionStorage.setItem('AddressBook_searchValue_admin',JSON.stringify(this.searchAdminValue))
    }
    public resetAdminSearchValue(){
        this.searchAdminValue = {
            zoneCode:'',
            zoneName:'',
            // enabled:''
        };
        this.addAdminNewVisible = false;
        // this.$refs.multipleTableAdmin.clearSort();
        this.$refs.paginationAdmin.resetSize();
        this.$refs.paginationAdmin.handleSizeChange(10);
        this.searchAdminFunc();
    }
    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('AddressBook_searchValue', JSON.stringify(this.searchValue));
    }
    public resetSearchValue() {
        this.searchValue = {
            addressName:'',
            addressCode:'',
            // enabled:'',
        };
        this.timeList = [];
        // this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }

    public expandType: boolean = false;
    public loading = false;
    public loadingAdmin = false;
    public rePagin = false;
    public reAdminPagin = false;
    public total = 20;
    public totalAdmin = 20;
    public isActive: boolean = false;
    public activeName = 'first';
    public tableData: any = [];
    public tableAdminData:any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await AddressBookApi.GetList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }
    public async loadAdminData(){
       this.loadingAdmin = true;
       try {
         let res = await AddressBookApi.GetZoneList({
            ...this.searchAdminValue,
            skip:this.searchPaginAdmin.skip,
            count:this.searchPaginAdmin.count,
         });
         this.tableAdminData = res.data;
         let skip = this.searchPaginAdmin.skip;
         this.$refs.paginationAdmin.setPage(this.searchPaginAdmin.currentPage);
         this.tableAdminData.map((item,index)=>{
            item.index = skip++ +1;
         });
         this.totalAdmin = res.total;
         this.loadingAdmin = false;
         /**无数据返回上一页 */
            if (this.searchPaginAdmin.currentPage > 1) {
                if (this.tableAdminData.length == 0) {
                    this.searchPaginAdmin.currentPage = this.searchPaginAdmin.currentPage - 1;
                    this.$refs.paginationAdmin.handleCurrentChange(this.searchPaginAdmin.currentPage);
                }
            }
       }
       catch{
          this.loadingAdmin = false;
       }
    }
    public fmObjToArr(data){
         let arr = [];
         arr.push({
            label:'运输区域',
            id:1,
            pid:'',
            icon:'el-icon-folder'
         })
         for(let key in data){
            arr.push({
                label:data[key],
                value:key,
                pid:1,
                id:key,
                icon:'el-icon-folder'
            })
         }
         return arr;
    }
    /**获取运输区域 */
    public arrTree = [];
    public async loadTreeData(data){
        let res = await AddressBookApi.GetAddressNameList({});
        console.log(this.fmObjToArr(res),'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
        let treeData = this.tranListToTreeData(this.fmObjToArr(res),'');
        console.log(treeData,'treedata')
        this.arrTree = treeData;
    };
    // filterChange() {
    //     this.loadTreeData(this.searchTreeValue.addressName);
    // }
    // 监听运输区域输入框变化
    @Watch('searchTreeValue.addressName')
    public addressNameChange(val: boolean) {
        this.$refs.vtree.filter(val);
    }
    public nodeClick(data,node){
        if (this.searchPagin.currentPage > 1) {           
             this.searchPagin.currentPage = 1;
             this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
        }
       this.addressInputName = '';
       this.searchValue.addressCode = '';
       if(data.label=='运输区域'){
          this.searchValue.addressName = '';
       }
       else {
         this.searchValue.addressName = data.label;
       }   
       this.searchFunc();
    }
    public filterNode(value,data){
      if(!value) return true;
      return data.label.indexOf(value) !== -1;
    }
    // 递归遍历树形结构
    public tranListToTreeData(list,rootValue){
        let arr = [];
        list.forEach((item,index)=>{
            if(item.pid===rootValue){
                let  children = this.tranListToTreeData(list,item.id)
                if(children.length){
                  item.children = children;
                }
                arr.push(item)
            }
        })
        return arr;
    }
    public handleClick(tab,event){
      if(this.activeName=='first'){
        this.loadAdminTreeData({});
      }
      else if (this.activeName=='two'){
         this.loadTreeData({});  
      }
    }
    public arrAdminTreeNew = []
    // 行政区域
    public arrAdminTree = [];
    public async loadAdminTreeData(data){
          let res = await AddressBookApi.GetTreeList({});
          this.arrAdminTree = res;
          this.arrAdminTree.forEach((item,index)=>{
              item.icon = 'el-icon-folder';
              if(item.children.length>0){
                item.children.forEach(i=>{
                    i.icon = 'el-icon-folder';
                    if(i.children.length>0){
                        i.children.forEach(j=>{
                            j.icon = 'el-icon-folder';
                        })
                    }
                });
              }
          });
          this.arrAdminTreeNew = [{
          text: '行政区划',
          id:1,
          icon:'el-icon-folder',
          children: this.arrAdminTree
        }]
          
    }
    // filterAdminChange(){
    //    this.loadAdminTreeData(this.searchAdminTreeValue.zoneName);
    // }
    // 监听行政区划输入框变化
    @Watch('searchAdminTreeValue.zoneName')
    public zoneNameChange(val: boolean) {
        this.$refs.vAdmintree.filter(val);
    }
    public filterAdminNode(value,data){
        if(!value) return true;
        return data.text.indexOf(value) !== -1;
    }
    public addAdminNewVisible:boolean = false;
    public parentName;
    public parentCode;
    nodeAdminClick(data,node){
    // 重新点击节点返回第一页
      if (this.searchPaginAdmin.currentPage > 1) {           
            this.searchPaginAdmin.currentPage = 1;
            this.$refs.paginationAdmin.handleCurrentChange(this.searchPaginAdmin.currentPage);
    }
    this.searchAdminValue = {
        zoneCode:'',
        zoneName:'',
    }
      if(node.level==2 || node.level==3){
        this.addAdminNewVisible = true;
      }   
      else{
        this.addAdminNewVisible = false;
      }
      if(node.level==2 || node.level==3){
        this.parentName = data.text;
        this.parentCode = data.value;
       };
       this.searchAdminValue.zoneParentCode = data.value;
       this.searchAdminValue.zoneParentName = data.text;
       this.searchAdminFunc();
    }
    public created() {
        this.selectReset = true;
        this.loadAdminTreeData({});
    }
    public mounted() {
        // 默认展开第一层
        // let nodedata = this.node.childNodes[0];
        // console.log(nodedata,'nodedata~~~~~~~~~~~~~~')
        // nodedata.expanded = true;
        // nodedata.loadData();
        this.$refs.draggerImg.imgdrager();
        if (sessionStorage.getItem('AddressBook_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('AddressBook_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.searchPagin = sessionStorage.getItem('AddressBook_page') ? JSON.parse(sessionStorage.getItem('AddressBook_page')) : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('AddressBook_page') ? JSON.parse(sessionStorage.getItem('AddressBook_page')) : this.searchPagin;

            this.loadData();
        }
         if (sessionStorage.getItem('AddressBook_searchValue_admin')) {
            this.searchAdminValue = JSON.parse(sessionStorage.getItem('AddressBook_searchValue_admin'));
            this.searchPaginAdmin = sessionStorage.getItem('AddressBook_page_admin') ? JSON.parse(sessionStorage.getItem('AddressBook_page_admin')) : this.searchPaginAdmin;
            this.loadAdminData();
        } else {
            this.searchPaginAdmin = sessionStorage.getItem('AddressBook_page_admin') ? JSON.parse(sessionStorage.getItem('AddressBook_page_admin')) : this.searchPaginAdmin;
            this.loadAdminData();
        }
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
       public searchPaginAdmin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('AddressBook_page', JSON.stringify(pagin));
        this.loadData();
    }
    public async onPaginationAdminChange(pagin:Pagination){
       this.searchPaginAdmin = pagin;
       sessionStorage.setItem('AddressBook_page_admin', JSON.stringify(pagin));
       this.loadAdminData();
    }
    // public node;
    // public loadAdminNode(node,resolve){
    //     console.log(node,'node~~~~~~~~~~~~~~~~')
    //    if(node.level==0){   
    //     this.node = node;
    //      return resolve([
    //         {
    //             text:'行政区划'
    //         }
    //      ])
    //    }
    //    else if(node.level ==1) {
    //       this.loadFirstAdmin(resolve)
    //    }
    //    else if(node.level==2) {
    //      this.loadSecondAdmin(node,resolve);      
    //    }
    //    else if(node.level==3) {
    //      this.loadThirdAdmin(node,resolve);
    //    }
    //    else {
    //       return resolve([]);
    //    }

    // }
    // public async loadFirstAdmin(resolve){
    //     let res = await AddressBookApi.GetProvince();
    //     return resolve(res.data);
    // }
    // public async loadSecondAdmin(node,resolve){
    //     let res = await AddressBookApi.GetCity(node.data.value);
    //     return resolve(res.data);
    // }
    // public async loadThirdAdmin(node,resolve){
    //     let res = await AddressBookApi.GetCountry(node.data.value);
    //     return resolve(res.data);
    // }
    public formData: any = {};
    public formDataAdmin:any = {};
    public title = '新增运输区域维护';
    public titleAdmin = '新增行政区'
    public async addAdminNew(){
        this.titleAdmin = '新增行政区';
        this.formDataAdmin = {};
        if(this.$refs.formDataAdmin){
            this.$refs.formDataAdmin.resetFields();
        }
        this.formDataAdmin.parentName = this.parentName;
        this.formDataAdmin.parentCode = this.parentCode;
        this.dialogVisibleAdmin = true;
    }
    public async addNew() {
        this.title = '新增运输区域维护';
        // this.content = '';     
        // this.formData = { 
        //     isEnable: true, 
        //     isDefault: false, 
        //     detail: '' 
        // };
        this.formData = {};
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }     
        // this.companyNames = [];
        // let result = await AddressBookApi.GetDropDownList();
        // result.forEach((item)=>{
        //     this.companyNames.push({
        //         label:item.shipperName,
        //         value: item.shipperName,
        //     })
        // })
        // var obj = { addressType: 1,isDefault:this.formData.isDefault };
        // this.formData = obj;
        this.dialogVisible = true;
    }
    public save() {
        let address = this.$refs.address.validateForm();
        this.$refs.formData.validate(async (valid) => {
            console.log(valid,'valid')
            if (address && valid) {
                if (this.title == '新增运输区域维护') {
                    // if (!this.formData.isEnable) {
                    //     this.formData.isDefault = false;
                    // }
                    console.log(this.formData,'this.formData~~~~~~~~~~~~~~~')
                    await AddressBookApi.AddOrEdit(this.formData);
                    this.$message.success('新增成功');
                    this.dialogVisible = false;
                    this.loadData();
                } else {
                    // if (!this.formData.isEnable) {
                    //     this.formData.isDefault = false;
                    // }
                    console.log(this.formData,'this.formdata')
                    await AddressBookApi.AddOrEdit(this.formData);
                    this.$message.success('编辑成功');
                    this.dialogVisible = false;
                    this.loadData();
                }
            }
             this.loadTreeData({}); 
        });
    }
    public adminId = null;
    public saveAdmin(){
       this.$refs.formDataAdmin.validate(async (valid)=>{
          if(valid){
            if(this.titleAdmin=='新增行政区'){
                await AddressBookApi.AddZone(this.formDataAdmin);
                this.$message.success('新增成功');
                this.dialogVisibleAdmin = false;
                this.loadAdminData();
            }
            else {
                await AddressBookApi.SaveZone(this.adminId,this.formDataAdmin);
                this.$message.success('编辑成功');
                this.dialogVisibleAdmin = false;
                this.loadAdminData();
            }
          }
          this.loadAdminTreeData({});
       })
    }
    public async toEditAdmin(id){
        this.adminId = id;
        this.titleAdmin = '编辑行政区';
        if(this.$refs.formDataAdmin){
            this.$refs.formDataAdmin.resetFields();
        }
        this.formDataAdmin = {};
        let res = await AddressBookApi.GetZone(id);
        this.formDataAdmin = res;
        this.dialogVisibleAdmin = true;

    }
    public async toEdit(id) {
        this.selectReset = false;
        this.title = '编辑运输区域维护';
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }
        this.formData = {};
        let res = await AddressBookApi.GetDetail(id);
        this.formData = res;

        this.SelectAddress.province.value = res.province;
        this.SelectAddress.city.value = res.city;
        this.SelectAddress.area.value = res.district;
        this.selectReset = true;
        this.dialogVisible = true;
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfigAdmin = {
        title:'',
        show:false,
    }
    confirmCloseAdmin(){
        this.dialogConfigAdmin = {
            title:'',
            show:false,
        }
    }
    confirmOkAdmin(){
        AddressBookApi.DeleteZone(this.idAdmin).then(()=>{
            this.$message.success('删除成功');
            this.loadAdminData();
            this.loadAdminTreeData({});
        })
         this.dialogConfigAdmin = {
            title: '',
            show: false,
        };
    }
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        AddressBookApi.DoDelete(this.id1).then(() => {
            this.$message.success('删除成功');
            this.loadData();
            this.loadTreeData({}); 
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public idAdmin:null;
    public toDelAdmin(id){
       this.idAdmin = id;
       this.dialogConfigAdmin = {
         title:'行政区',
         show:true,
       }
    }
    public id1: number;
    public toDel(id) {
        this.id1 = id;
        this.dialogConfig2 = {
            title: '地址',
            show: true,
        };
        // this.$confirm('确认删除该地址?', '地址删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         AddressBookApi.DoDelete(id).then(() => {
        //             this.$message.success('删除成功');
        //             this.loadData();
        //         });
        //     })
        //     .catch(() => {});
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
}
